export enum ProcessingPaymentState {
  PENDING,
  SUCCEEDED,
  FAILED,
}